// @flow
import { createUniversalRoute } from "../../utils/createUniversalRoute";

const routes = [
  {
    path: "/book-a-call",
    exact: true,
    name: "OnePageForm",
  },
  {
    path: "/book-a-call/thank-you",
    name: "OnePageFormThankYou",
  },
];

export const onePageFormRoutes = routes.map<*>(createUniversalRoute);
